/* tslint:disable */
/* eslint-disable */
export enum VisaTypeEnum {
  None = 'None',
  WorkingVisa = 'WorkingVisa',
  ResidentVisa = 'ResidentVisa'
}
